import { datadogLogs } from '@datadog/browser-logs';
import { LogMetadataProvider } from '@tv2-player/unifiedplayer/src/types/LogMetadataProvider';
import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { getPublicRuntimeEnv } from '@tv2/lib-offspring/libs/publicEnv';

let isInitialized = false;
export function initDatadogLogs(trackingGranted: boolean) {
  if (isInitialized) {
    // If it is initialized, we only need to update the tracking consent
    datadogLogs.setTrackingConsent(trackingGranted ? 'granted' : 'not-granted');
    return;
  }

  isInitialized = true;

  const env = getPublicRuntimeEnv();

  datadogLogs.init({
    clientToken: env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'pwbs.offspring',
    forwardErrorsToLogs: true,
    sessionSampleRate: 1, // Only log 1% of sessions
    version: env.APP_VERSION,
    env: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
    trackingConsent: trackingGranted ? 'granted' : 'not-granted',
    beforeSend: event => {
      if (event.message?.startsWith('xhrRequest')) {
        return false;
      }
      if (event.message?.startsWith('Failed to fetch')) {
        return false;
      }
      if (event.message?.startsWith('Fetch error GET')) {
        return false;
      }
      if (event.message?.startsWith('Fetch error POST')) {
        return false;
      }
      if (event.message?.startsWith('Network request failed')) {
        return false;
      }
      if (event.message?.startsWith('The user aborted a request')) {
        return false;
      }
      if (event.message === 'Aborted') {
        return false;
      }

      const metadata = ServiceContainer.get(LogMetadataProvider)?.getMetadata();
      event.metadata = metadata;
      return true;
    },
  });
}
